// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Accounts.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  AdminAuditCreditBalanceRequest,
  AdminAuditCreditBalanceResponse,
  AdminGetAccountAppsRequest,
  AdminGetAccountAppsResponse,
  AdminGetAccountHostsRequest,
  AdminGetAccountHostsResponse,
  AdminGetAccountRequest,
  AdminGetAccountResponse,
  AdminGetAccountsRequest,
  AdminGetAccountsResponse,
  AdminGetAccountUsersRequest,
  AdminGetAccountUsersResponse,
  AdminSetStorageLimitsRequest,
  AdminUpdateAccountRequest,
  ArchiveUserRequest,
  ArchiveUserResponse,
  CreateUserRequest,
  CreateUserResponse,
  GetAccountRequest,
  GetAccountResponse,
  GetUserRequest,
  GetUserResponse,
  GetUsersRequest,
  GetUsersResponse,
  UpdateAccountRequest,
  UpdateAccountResponse,
  UpdateUserRequest,
  UpdateUserResponse,
} from "./Models/AccountModels";

export const protobufPackage = "daisi.protos.v1";

export type AccountsProtoDefinition = typeof AccountsProtoDefinition;
export const AccountsProtoDefinition = {
  name: "AccountsProto",
  fullName: "daisi.protos.v1.AccountsProto",
  methods: {
    get: {
      name: "Get",
      requestType: GetAccountRequest,
      requestStream: false,
      responseType: GetAccountResponse,
      responseStream: false,
      options: {},
    },
    update: {
      name: "Update",
      requestType: UpdateAccountRequest,
      requestStream: false,
      responseType: UpdateAccountResponse,
      responseStream: false,
      options: {},
    },
    createUser: {
      name: "CreateUser",
      requestType: CreateUserRequest,
      requestStream: false,
      responseType: CreateUserResponse,
      responseStream: false,
      options: {},
    },
    getUser: {
      name: "GetUser",
      requestType: GetUserRequest,
      requestStream: false,
      responseType: GetUserResponse,
      responseStream: false,
      options: {},
    },
    getUsers: {
      name: "GetUsers",
      requestType: GetUsersRequest,
      requestStream: false,
      responseType: GetUsersResponse,
      responseStream: false,
      options: {},
    },
    archiveUser: {
      name: "ArchiveUser",
      requestType: ArchiveUserRequest,
      requestStream: false,
      responseType: ArchiveUserResponse,
      responseStream: false,
      options: {},
    },
    updateUser: {
      name: "UpdateUser",
      requestType: UpdateUserRequest,
      requestStream: false,
      responseType: UpdateUserResponse,
      responseStream: false,
      options: {},
    },
    /** Admin RPCs */
    adminGetAccounts: {
      name: "AdminGetAccounts",
      requestType: AdminGetAccountsRequest,
      requestStream: false,
      responseType: AdminGetAccountsResponse,
      responseStream: false,
      options: {},
    },
    adminGetAccount: {
      name: "AdminGetAccount",
      requestType: AdminGetAccountRequest,
      requestStream: false,
      responseType: AdminGetAccountResponse,
      responseStream: false,
      options: {},
    },
    adminUpdateAccount: {
      name: "AdminUpdateAccount",
      requestType: AdminUpdateAccountRequest,
      requestStream: false,
      responseType: UpdateAccountResponse,
      responseStream: false,
      options: {},
    },
    adminAuditCreditBalance: {
      name: "AdminAuditCreditBalance",
      requestType: AdminAuditCreditBalanceRequest,
      requestStream: false,
      responseType: AdminAuditCreditBalanceResponse,
      responseStream: false,
      options: {},
    },
    adminSetStorageLimits: {
      name: "AdminSetStorageLimits",
      requestType: AdminSetStorageLimitsRequest,
      requestStream: false,
      responseType: UpdateAccountResponse,
      responseStream: false,
      options: {},
    },
    adminGetAccountUsers: {
      name: "AdminGetAccountUsers",
      requestType: AdminGetAccountUsersRequest,
      requestStream: false,
      responseType: AdminGetAccountUsersResponse,
      responseStream: false,
      options: {},
    },
    adminGetAccountHosts: {
      name: "AdminGetAccountHosts",
      requestType: AdminGetAccountHostsRequest,
      requestStream: false,
      responseType: AdminGetAccountHostsResponse,
      responseStream: false,
      options: {},
    },
    adminGetAccountApps: {
      name: "AdminGetAccountApps",
      requestType: AdminGetAccountAppsRequest,
      requestStream: false,
      responseType: AdminGetAccountAppsResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface AccountsProtoServiceImplementation<CallContextExt = {}> {
  get(request: GetAccountRequest, context: CallContext & CallContextExt): Promise<DeepPartial<GetAccountResponse>>;
  update(
    request: UpdateAccountRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<UpdateAccountResponse>>;
  createUser(
    request: CreateUserRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CreateUserResponse>>;
  getUser(request: GetUserRequest, context: CallContext & CallContextExt): Promise<DeepPartial<GetUserResponse>>;
  getUsers(request: GetUsersRequest, context: CallContext & CallContextExt): Promise<DeepPartial<GetUsersResponse>>;
  archiveUser(
    request: ArchiveUserRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<ArchiveUserResponse>>;
  updateUser(
    request: UpdateUserRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<UpdateUserResponse>>;
  /** Admin RPCs */
  adminGetAccounts(
    request: AdminGetAccountsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<AdminGetAccountsResponse>>;
  adminGetAccount(
    request: AdminGetAccountRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<AdminGetAccountResponse>>;
  adminUpdateAccount(
    request: AdminUpdateAccountRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<UpdateAccountResponse>>;
  adminAuditCreditBalance(
    request: AdminAuditCreditBalanceRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<AdminAuditCreditBalanceResponse>>;
  adminSetStorageLimits(
    request: AdminSetStorageLimitsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<UpdateAccountResponse>>;
  adminGetAccountUsers(
    request: AdminGetAccountUsersRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<AdminGetAccountUsersResponse>>;
  adminGetAccountHosts(
    request: AdminGetAccountHostsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<AdminGetAccountHostsResponse>>;
  adminGetAccountApps(
    request: AdminGetAccountAppsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<AdminGetAccountAppsResponse>>;
}

export interface AccountsProtoClient<CallOptionsExt = {}> {
  get(request: DeepPartial<GetAccountRequest>, options?: CallOptions & CallOptionsExt): Promise<GetAccountResponse>;
  update(
    request: DeepPartial<UpdateAccountRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<UpdateAccountResponse>;
  createUser(
    request: DeepPartial<CreateUserRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CreateUserResponse>;
  getUser(request: DeepPartial<GetUserRequest>, options?: CallOptions & CallOptionsExt): Promise<GetUserResponse>;
  getUsers(request: DeepPartial<GetUsersRequest>, options?: CallOptions & CallOptionsExt): Promise<GetUsersResponse>;
  archiveUser(
    request: DeepPartial<ArchiveUserRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<ArchiveUserResponse>;
  updateUser(
    request: DeepPartial<UpdateUserRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<UpdateUserResponse>;
  /** Admin RPCs */
  adminGetAccounts(
    request: DeepPartial<AdminGetAccountsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<AdminGetAccountsResponse>;
  adminGetAccount(
    request: DeepPartial<AdminGetAccountRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<AdminGetAccountResponse>;
  adminUpdateAccount(
    request: DeepPartial<AdminUpdateAccountRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<UpdateAccountResponse>;
  adminAuditCreditBalance(
    request: DeepPartial<AdminAuditCreditBalanceRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<AdminAuditCreditBalanceResponse>;
  adminSetStorageLimits(
    request: DeepPartial<AdminSetStorageLimitsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<UpdateAccountResponse>;
  adminGetAccountUsers(
    request: DeepPartial<AdminGetAccountUsersRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<AdminGetAccountUsersResponse>;
  adminGetAccountHosts(
    request: DeepPartial<AdminGetAccountHostsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<AdminGetAccountHostsResponse>;
  adminGetAccountApps(
    request: DeepPartial<AdminGetAccountAppsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<AdminGetAccountAppsResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
